import type { SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc = (isUsageBased) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: 0,
  maxWidth: '100%',
  background: isUsageBased
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.common.white,
  padding: (p) => p.spacing(1.5),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  borderRadius: (p) => p.spacing(0.5),
  boxSizing: 'border-box',
});

export const compactRoot: SxStyleFunc<boolean | undefined> = (
  isMostPopular
) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: 0,
  maxWidth: '100%',
  background: isMostPopular
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.common.white,
  padding: (p) => p.spacing(1.5),
  border: 'none',
  borderRadius: 0,
  boxSizing: 'border-box',
});
